import { motion } from "framer-motion";
import { Reveal } from "./Reveal";
import { Monogram } from "./Wordmark";

export default function Philosophy() {
  return (
    <section
      id="story"
      data-testid="philosophy-section"
      className="relative py-28 md:py-40 overflow-hidden"
      style={{
        background:
          "linear-gradient(180deg, #FFFFFF 0%, #E9E7E4 45%, #DEDCD8 75%, #F2F0ED 100%)",
      }}
    >
      <div className="mx-auto max-w-[1300px] px-6 md:px-12 grid grid-cols-1 md:grid-cols-[1fr_1.2fr] gap-14 md:gap-20 items-start">
        {/* headline + tall vertical rule + vi — per the mockup */}
        <div className="relative">
          <Reveal>
            <h2 className="font-sans font-normal uppercase text-[#14100C] text-3xl sm:text-4xl md:text-[2.5rem] leading-[1.3] tracking-[0.1em]">
              Modern luxury,
              <br />
              made effortless.
            </h2>
          </Reveal>
          <motion.span
            aria-hidden
            className="hidden md:block absolute top-2 left-[105%] h-[420px] w-px bg-ink/60 origin-top"
            initial={{ scaleY: 0 }}
            whileInView={{ scaleY: 1 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 1.6, ease: [0.22, 1, 0.36, 1] }}
          />
          <Reveal delay={0.3}>
            <Monogram className="h-14 md:h-16 mt-16 md:mt-40 md:ml-2" tone="ink" />
          </Reveal>
        </div>

        {/* paragraph — right, bold Vivoré lead */}
        <Reveal delay={0.2}>
          <div className="md:pt-10 max-w-xl space-y-6">
            <p className="font-sans font-normal text-[15px] md:text-[17px] leading-[1.9] text-[#14100C]">
              <span className="font-semibold">Vivoré</span> is a modern luxury
              skincare brand built on the belief that beauty should feel
              effortless, elevated, and timeless.
            </p>
            <p className="font-sans font-normal text-[15px] md:text-[17px] leading-[1.9] text-[#14100C]">
              We combine exceptional ingredients, refined formulations, and
              elegant design to create a luxurious skincare experience without
              compromise.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
